
import { Options, Vue } from 'vue-class-component';
import EventBusService from "@/services/EventBusService";
import { EventNotification } from "@/data/eventbus";

const durationTimings = {
    long: 8000,
    default: 5000,
    short: 3000,
};

@Options({
    components: {

    },
})
export default class App extends Vue {
    handleNotification(notification: EventNotification) {
        this.$notify({
            type: notification?.type,
            text: notification.message,
            duration: durationTimings[notification?.duration || 'default'],
        });
    }
    mounted() {
        EventBusService.$on('notification', this.handleNotification);
    }
}
